<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Dokumen yang Ditolak"
        class="card-wrapper"
        >
        
        <v-card>
            <div class="col-8">
            <v-text-field
            v-model="search"
            class="esign-table-search"
            prepend-inner-icon="mdi-magnify"
            label="Cari di tabel"
            outlined
            dense
            clearable
            single-line
            hide-details
          ></v-text-field>
            </div>
       
            <v-data-table
                :headers="filteredHeaders"
                :search="search"
                :items="items"
                no-data-text="Tidak ada data"
                class="elevation-1"
                :loading="isLoading"
                loading-text="Memuat data..."
                :options.sync="options"
                hide-default-footer  
            >
              <template v-slot:footer="{ props, on }">
                <esign-table-footer
                :pagination="props.pagination"
                :options="props.options"
                @update:options="on['update:options']"
                />
              </template>
              <template v-slot:item.status_dokumen="{ item }">
                <esign-status-tag :value="item.status_dokumen" />
              </template>
                <template
                    v-for="header in filteredHeaders.filter((header) =>
                      header.hasOwnProperty('formatter')
                    )"
                    v-slot:[`item.${header.value}`]="{ header, value }"
                  >
                    {{ header.formatter(value) }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-row>
                    <v-btn style="margin:auto" small color="primary" dark @click="detailItem(item)">Detail</v-btn>
                  </v-row>
                </template>
            </v-data-table><br>
            
            <br><br><br>
        </v-card>
        
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        </material-card>
    </v-container>
  </template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";
var moment = require('moment');
export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["search", "options"],
  data: () => ({
    search: "",
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    isLoading: true,
    menu: false,
    dialog: false,
    jenisDokumens: [],
    statusDokumens: [],
    items: [],
    // headers: [],
    // searchForm: {
    //   nomorPengajuan: "",
    //   namaPenandatangan: "",
    //   nama: "",
    //   jenisDokumen: -1,
    //   tanggalPengajuan: null,
    //   statusDokumen: -1,
    //   userId: -1,
    //   usernamePengaju: ""
    // },
    options: {},
    totalData: 0,
    rejectTotal:0,
    tgl:null,
    bulk_list: [],
    verify_bulk: false,
    peran: "",
    user: null,
  }),
  computed: {
    // filteredJenisDokumen(){
    //     return this.jenisDokumens.filter(item => item.status)
    // },
    filteredHeaders() {
      const headers = [
        { text: "Nomor Pengajuan", value: "nomor_pengajuan", cellClass: "esign-cell-break" },
        { text: "Tanggal Pengajuan", value: "tanggal_pengajuan", sortable: true, formatter: (x) => (x ? moment.utc(x).locale("id").format('DD-MM-YYYY HH:mm:ss') : null), },
        { text: "Nomor Surat", value: "nomor_surat", cellClass: "esign-cell-break" },
        { text: "Jenis Dokumen", value: "nama_jenis_dokumen"},
        { text: "Nama Organisasi", value: "nama_organisasi"},
        { text: "Nama Penandatangan", value: "nama_penandatangan"},
        { text: "Username Pengaju", value: "username_pengaju"},
        { text: "Alasan Penolakan", value: "keterangan"},
        { text: "Status", value: "status_dokumen"},
        { text: "Aksi", align:"center", value: "action", sortable: false}
      ]
      return headers
    }
  },
  created() {
    this.peran =localStorage.getItem("currentPeran"),
    this.user= JSON.parse(localStorage.getItem("user"))
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    // paging/sorting is done by the table itself, so the list is loaded once
    this.getData()
  },
  methods: {
    getData() {
      this.isLoading = true;
      // console.log("search form", JSON.stringify(this.searchForm));
      // let tanggal_pengajuan = null
      // if (this.searchForm.tanggalPengajuan) {
      //   tanggal_pengajuan = moment(this.searchForm.tanggalPengajuan).format('DD-MM-YYYY')
      // }
    //   if (this.peran=='A03') {
    //     this.searchForm.userId = this.user.id
    //   }
    //   if (this.peran=='A02') {
    //     this.searchForm.usernamePengaju = this.user.username
    //   }
      apiServer
        .get("/arsip/reject_list", {
          params: {
            username_pengaju: this.user.username
          }
        })
        .then(response => {
          this.isLoading = false;
          console.log(JSON.stringify(response.data.data))
          this.items = response.data.data;
          this.totalData = this.items.length
          this.rejectDokumen = this.items.length
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    detailItem(item) {
      this.$router.push('/dokumen/detail/'+item.id_arsip);
    }
  }
};
</script>